<template>
  <div
    class="rounded-full px-4 py-2 cursor-pointer select-none"
    tabindex="0"
    :class="
      checked ? 'text-primaryText bg-primary-600 ' : 'text-slate-600 bg-slate-200'
    "
    @keydown.enter="() => toggleChecked(!checked)"
    @click="() => toggleChecked(!checked)"
  >
    {{ name }}
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  name: String,
  checked: Boolean,
  isAtMax: Boolean,
});

const checked = ref(props.checked);

const toggleChecked = (shouldBeToggled) => {
  if (props.isAtMax && shouldBeToggled) return;
  checked.value = !checked.value;
};

watch(() => props.checked,() => checked.value = props.checked);
</script>
